/**
 * Redesigned PSYPACT states page (views/redesign/pages/about/psypact.ejs).
 *
 * "Check your state": picking a state says whether Dr. Caudill can see the
 * visitor there and highlights its tile on the map. Statuses come from the
 * page's data-psy-status attribute (config/team/psypact-states.json), and the
 * state names from the picker's own options, so nothing here is hard-coded.
 * Umami gets the outcome only, never the state picked.
 */

const UMAMI_RESULT = { home: 'texas', pact: 'psypact', none: 'no' };

export function resultText(status, name, homeName) {
    if (status === 'home') {
        return `Yes. Dr. Caudill is licensed in ${homeName}, so she can see you in person or by telehealth.`;
    }
    if (status === 'pact') {
        return `Yes. Dr. Caudill can see you by telehealth while you are in ${name.replace(/\.$/, '')}.`;
    }
    return `Not by telehealth. ${name} is not a PSYPACT state. You can still see her in person in McKinney, or work with a coach.`;
}

export function initPsypactCheck(root = document) {
    const check = root.querySelector('.psy-check[data-psy-status]');
    const sel = root.getElementById ? root.getElementById('psyState') : root.querySelector('#psyState');
    const out = root.querySelector('#psyResult');
    if (!check || !sel || !out || check.dataset.psyInitialized === 'true') return;
    check.dataset.psyInitialized = 'true';

    let status = {};
    try {
        status = JSON.parse(check.dataset.psyStatus) || {};
    } catch {
        return;
    }
    const homeOption = [...sel.options].find(o => status[o.value] === 'home');
    const homeName = homeOption ? homeOption.textContent.trim() : 'Texas';
    const tiles = root.querySelectorAll('.usmap__tile');

    sel.addEventListener('change', () => {
        const code = sel.value;
        const s = status[code];
        const name = sel.options[sel.selectedIndex]?.textContent.trim() || '';
        tiles.forEach(t => t.classList.toggle('is-picked', t.dataset.state === code));
        out.className = 'psy-check__result' + (s ? ` psy-check__result--${s}` : '');
        out.textContent = code && s ? resultText(s, name, homeName) : '';
        if (code && s) window.umami?.track?.('psypact_state_check', { result: UMAMI_RESULT[s] });
    });
}

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initPsypactCheck());
    } else {
        initPsypactCheck();
    }
}
